"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAdministratorEmailsDto = void 0;
class CompanyAdministratorEmailsDto {
}
exports.CompanyAdministratorEmailsDto = CompanyAdministratorEmailsDto;
//# sourceMappingURL=company-administrator-emails.dto.js.map